import React from "react";
import ReactDOM from "react-dom";
import * as myServiceWorker from './myServiceWorker';

import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));